import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { lazy } from "react";
import Icon from "../../../base/icons/icon/index.js";
import SearcherFlightHotel from "../searcher-flight-hotel/index.js";
import SearcherMultiPak from "../searcher-multi-pak/index.js";
import SearcherSwitcher from "../searcher-switcher/index.js";
import { SearcherTabsVariant } from "./types.js";
const getIcon = (id)=>({
        FLI_HOT: 'plane-hotel',
        FER_HOT: 'ferry',
        TRA_HOT: 'train',
        MUL_PAK: 'suitcase',
        LEI: 'hot-air-balloon',
        TOU: 'palm-tree',
        LINK: 'compass',
        CIR: 'earth-arrow',
        CRU: 'cruise',
        DIS: 'big-wheel',
        FLI: 'plane',
        FER: 'ferry',
        HOT: 'hotel',
        TRA: 'train',
        CAR: 'car',
        shk: 'compass',
        DEST: 'earth-globe'
    })[id] ?? '';
const SearcherTrainHotel = /*#__PURE__*/ lazy(()=>import("../searcher-train-hotel/index.js"));
const SearcherFerryHotel = /*#__PURE__*/ lazy(()=>import("../searcher-ferry-hotel/index.js"));
const SearcherTou = /*#__PURE__*/ lazy(()=>import("../searcher-tou/index.js"));
const SearcherLei = /*#__PURE__*/ lazy(()=>import("../searcher-lei/index.js"));
const SearcherCir = /*#__PURE__*/ lazy(()=>import("../searcher-cir/index.js"));
const SearcherCru = /*#__PURE__*/ lazy(()=>import("../searcher-cru/index.js"));
const SearcherDisney = /*#__PURE__*/ lazy(()=>import("../searcher-disney/index.js"));
const SearcherFlight = /*#__PURE__*/ lazy(()=>import("../searcher-fli/index.js"));
const SearcherFerry = /*#__PURE__*/ lazy(()=>import("../searcher-fer/index.js"));
const SearcherHotel = /*#__PURE__*/ lazy(()=>import("../searcher-hot/index.js"));
const SearcherTrain = /*#__PURE__*/ lazy(()=>import("../searcher-tra/index.js"));
const SearcherCar = /*#__PURE__*/ lazy(()=>import("../searcher-car/index.js"));
const SearcherActivities = /*#__PURE__*/ lazy(()=>import("../searcher-activities/index.js"));
const SearcherDestination = /*#__PURE__*/ lazy(()=>import("../searcher-destination/index.js"));
const searchers = {
    FLI_HOT: SearcherFlightHotel,
    TRA_HOT: SearcherTrainHotel,
    FER_HOT: SearcherFerryHotel,
    MUL_PAK: SearcherMultiPak,
    TOU: SearcherTou,
    LEI: SearcherLei,
    CIR: SearcherCir,
    CRU: SearcherCru,
    DIS: SearcherDisney,
    FLI: SearcherFlight,
    FER: SearcherFerry,
    HOT: SearcherHotel,
    TRA: SearcherTrain,
    CAR: SearcherCar,
    ACTIVITIES: SearcherActivities,
    DEST: SearcherDestination
};
export const transformTabs = (tabs = [], config, variant = SearcherTabsVariant.Default)=>tabs?.map((tab, index)=>{
        const { id , title , searcher , endpoint , ajaxComponentData , link , hideIcon =variant === SearcherTabsVariant.Buttons , redirect  } = tab;
        const label = /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                id && !hideIcon && /*#__PURE__*/ _jsx(Icon, {
                    className: `nico-${getIcon(id)}`
                }),
                title
            ]
        });
        return {
            label: link ? /*#__PURE__*/ _jsx("a", {
                href: link,
                children: label
            }) : label,
            index,
            element: /*#__PURE__*/ _jsx(SearcherSwitcher, {
                searchers: searchers,
                id: id,
                searcher: searcher,
                endpoint: endpoint,
                ajaxComponentData: ajaxComponentData,
                config: config
            }, id),
            data: {
                isLink: !!link || redirect
            }
        };
    });

//# sourceMappingURL=utils.js.map